import { FeedbackInstantService } from './../feedbackInstant/feedback-instant.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { NotificationDto } from '../../dto/notification-center/notification.dto';
import { BEEHOME_API_URL, SERVER_URL } from '../../config';
import { UtilService } from '../util/util.service';
import { MenuService } from '../menu/menu.service';
import { TranslateService } from '@ngx-translate/core';

interface NotificationListPage {
  items: NotificationDto[];
  nextCursor: string | null;
  hasMore: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationCenterService {
  private httpClient = inject(HttpClient);
  private menuService = inject(MenuService);
  private utilService = inject(UtilService);
  private translate = inject(TranslateService);
  feedbackinstant = inject(FeedbackInstantService);

  countUnseenNotifications: number;
  notifications: NotificationDto[] = [];
  nextCursor: string | null = null;
  hasMore = false;

  private get base(): string {
    return `${SERVER_URL}${BEEHOME_API_URL}/pod/notifications`;
  }

  // Count de não-visualizadas, cap em 100 (backend retorna { count, capped }).
  // Frontend só precisa saber se é >99 para mostrar "+99" no badge.
  countUnviewedNotifications = () => this.httpClient.get<{ count: number; capped: boolean }>(`${this.base}/unviewed/count`).pipe(map((data) => {
    this.countUnseenNotifications = data?.count ?? 0;
    return this.countUnseenNotifications;
  }));

  // Lista paginada por cursor. Se `append=true`, anexa à lista atual (infinite scroll);
  // senão, substitui (primeira página / refresh).
  listUserNotifications = (startDate: number = null, endDate: number = null, cursor: string = null, pageSize = 20, append = false) => {
    const params: string[] = [`pageSize=${pageSize}`];
    if (startDate != null) params.push(`startDate=${startDate}`);
    if (endDate != null) params.push(`endDate=${endDate}`);
    if (cursor) params.push(`cursor=${encodeURIComponent(cursor)}`);
    const url = `${this.base}?${params.join('&')}`;
    return this.httpClient.get<NotificationListPage>(url).pipe(map((page) => {
      const formatted = this.formatNotification(page.items || []);
      this.notifications = append ? [...this.notifications, ...formatted] : formatted;
      this.nextCursor = page.nextCursor;
      this.hasMore = page.hasMore;
      return page;
    }));
  }

  // Marca até 1000 como vistas por chamada. Retorna { marked, hasMore }.
  // Caller encadeia chamadas se hasMore=true.
  viewAllNotifications = () => this.httpClient.put<{ marked: number; hasMore: boolean }>(`${this.base}/viewall`, null);

  // Busca uma notification específica por createdOn.
  getNotification = (createdOn: string) =>
    this.httpClient.get<NotificationDto>(`${this.base}/one?createdOn=${encodeURIComponent(createdOn)}`);

  // Marca uma notification como lida.
  readNotification = (createdOn: string) =>
    this.httpClient.put<NotificationDto>(`${this.base}/read?createdOn=${encodeURIComponent(createdOn)}`, null);

  getEntityUrl = (notificationDto: NotificationDto) => {
    const { resourceId, resourceType, entityType, parentId } = notificationDto;
    const urlOptions = {
      'br.com.ui2.model.news.News': `/news/${resourceId}/detail`,
      'br.com.ui2.model.event.Event': `/events/${resourceId}/detail`,
      'br.com.ui2.model.video.Video': `/video/${resourceId}/detail`,
      'br.com.ui2.model.poll.Poll': `/poll/${resourceId}/detail`,
      'br.com.ui2.model.cms.ContentFile': `/cms/${resourceId}/detail`,
      'br.com.ui2.model.wiki.WikiPage': `/wiki/${resourceId}/detail`,
      'br.com.ui2.model.photoBook.PhotoBook': `/photoBook/${resourceId}/detail`,
      'br.com.ui2.model.group.Group': `/workGroup/${resourceId}/detail`,
      'br.com.ui2.model.blog.BlogPost': `/blog/${resourceId}/detail`,
      'br.com.ui2.model.chat.ChatPost': `/message/${parentId}/detail`,
      'br.com.ui2.model.beezz.BeezzComment': `/beezz/${resourceId}/detail`,
      'br.com.ui2.model.workflow.Workflow': (resourceId > 0 ? `/workflow/step/${resourceId}` : `/workflow`),
      'br.com.ui2.model.user.User': `directory/${resourceId}/profile`,
      'br.com.ui2.model.performanceMGMT.PerformanceMGMT': `/performanceMGMT`
    };
    const entityUrl = urlOptions[resourceType ? resourceType : ''];
    return entityUrl ? entityUrl : (entityType ? `/${entityType.toLowerCase()}/${parentId ? parentId : resourceId}/detail` : '');
  };

  private fixEncoding(text: string): string {
    if (!text || !/Ã[£¡¢©§ª]|Ã\u00a9|Ã\u00ad|Ã\u00b3/.test(text)) return text;
    try {
      const bytes = new Uint8Array([...text].map(c => c.charCodeAt(0)));
      return new TextDecoder('utf-8').decode(bytes);
    } catch { return text; }
  }

  formatNotification = (notificationDtoList: NotificationDto[]) => {
    for (const notificationDto of notificationDtoList) {
      notificationDto.action = this.fixEncoding(notificationDto.action);
      notificationDto.title = this.fixEncoding(notificationDto.title);
      notificationDto.label = this.fixEncoding(notificationDto.label);
      let feedbackSendBy: any;
      if (notificationDto && notificationDto.label && notificationDto.label.indexOf('Uma trilha \'null') !== -1) {
        notificationDto.label = notificationDto.label.replace('Uma trilha \'null', 'cadastrou uma trilha que está pendente aprovação');
      }
      const {  action, title, label, entityType,resourceId} = notificationDto;
      let sentBy :any;
      let userId :any;
      let userName :any;
      if(notificationDto?.sentBy){
        sentBy =notificationDto.sentBy;
        userId = notificationDto.sentBy.id;
        userName = notificationDto.sentBy.name;
      }
      if (entityType && (entityType.toLowerCase() === 'happy'|| entityType.toLowerCase() === 'paycheck')) {
        notificationDto.sentBy = null;
        notificationDto.message = `${label ? `${label}.` : `${action} ${title}.`}`;
      } else if (entityType && entityType.toLowerCase() === 'feedback' && action &&
                (action.toLowerCase()==='enviou um novo feedback a você' || action.toLowerCase()==='sent you new feedback' || action.toLowerCase()==='te ha dado su feedback')){
                  feedbackSendBy=notificationDto.sentBy;
                  notificationDto.sentBy = null;
          this.feedbackinstant.getFeedbackInstantGive(resourceId).subscribe((data)=>{
          if (data!=null && data.anonymous){
          if(action.toLowerCase()==='enviou um novo feedback a você'){
          notificationDto.message = `${'Usuário anônimo'} ${label ? `${label}.` : `${action} ${title}.`}`;
          }else if(action.toLowerCase()==='sent you new feedback'){
            notificationDto.message = `${'Anonymous user'} ${label ? `${label}.` : `${action} ${title}.`}`;
          }
          else if( action.toLowerCase()==='te ha dado su feedback'){
            notificationDto.message = `${'Usuario anónimo'} ${label ? `${label}.` : `${action} ${title}.`}`;
          }
        } else {
          notificationDto.sentBy = feedbackSendBy;
          notificationDto.message = `${this.menuService?.loggedUserId === Number(userId) ? 'Você' : userName} ${label ? `${label}.` : `${action} ${title}.`}`;
        }
      });
      } else {
        notificationDto.message = `${this.menuService?.loggedUserId === Number(userId) ? 'Você' : (userName ? userName : '')} ${label ? `${label}.` : `${action} ${title}.`}`;
      }
    }
    return notificationDtoList;
  };
}
